<template lang="pug">
.brief
  title-bar {{ $t('Brief信息') }}

  .brief__main
    el-row
      el-col(:span="4") {{ $t('项目名称') }}
      el-col(:span="20") {{ brief.campaign_name }}

    template(
      v-for="(item, idx) in brief.brand"
    )
      el-row
        el-col(:span="4") {{ $t('品牌类别') }}
        el-col(:span="20") {{ item.brand_category_name }}

      el-row
        el-col(:span="4") {{ $t('品牌') }}
        el-col(:span="20") {{ item.brand_name }}

    Category(:data="brief.category")

    el-row
      el-col(:span="4") {{ $t('上线时间') }}
      el-col(:span="20") {{ brief.start_date | formatDate }} ~ {{ brief.end_date | formatDate }}

    el-row
      el-col(:span="4") {{ $t('附件') }}
      el-col(:span="20")
        a(:href="brief.brief_download_url" download) {{ brief.brief_name }}

    el-row
      el-col(:span="4") {{ $t('方案截止回复日期') }}
      el-col(:span="20") {{ brief.deadline | formatDate }}

    el-row
      el-col(:span="4") {{ $t('描述') }}
      el-col(:span="20") {{ brief.introduction || '—' }}

</template>

<script>
import axios from 'axios'
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import Category from '@/components/Category'
import { formatDate } from '@/umcc/util'

export default {
  components: {
    TitleBar,
    FooterButton,
    Category
  },
  data () {
    return {
      brief: {
        name: '-',
        brand_category: '-',
        brand: '-',
        category: [],
        period: '-',
        file_name: '-',
        deadline: '-',
        desc: '-'
      }
    }
  },
  mounted: function () {
    axios.get('/vendor/vendor/getBriefInfo', {params: {campaign_id: this.$store.state.campaign.id}})
      .then(res => {
        this.brief = res
      })
  },
  filters: {
    formatDate
  }
}
</script>

<style lang="stylus">
.brief__main
  margin-left 20px
</style>
